import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";
import "./footer.css";

function FooterAll() {
  return (
    <div className="footer">

      <div className="footer-content">
        <p className="footer-text">
          © 2025{" "}
          <a 
            href="https://fazoacademy.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-link"
          >
            Fazo Academy
          </a>{" "}
          — All rights reserved.
        </p>

        <div className="social-icons">
          <a href="https://www.facebook.com/share/1G4PfTp6Bv/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.linkedin.com/company/fazo-academy/" target="_blank" rel="noopener noreferrer" className="linkedin">
            <FaLinkedinIn />
          </a>
          <a href="https://wa.me/916380866249" target="_blank" rel="noopener noreferrer" className="whatsapp">
            <FaWhatsapp />
          </a>
          <a href="https://www.instagram.com/fazo_academy?utm_source=qr&igsh=MWR3djJ4cHJsejlnOA==" target="_blank" rel="noopener noreferrer" className="instagram">
            <FaInstagram />
          </a>
        </div>
      </div>

    </div>
  );
}

export default FooterAll;
